import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { useStore } from "./state.js";
import { getStorage, Logout } from "./helper";
import { setNavigate } from './navigationHelper';
import { IdleTimerProvider } from 'react-idle-timer';

import { Button, Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import Form from 'react-bootstrap/Form';
import {
  Routes,
  Route,
  BrowserRouter,
  Link,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";

import reportWebVitals from './reportWebVitals';

import './styles.css';
import MainLayout from "./layout";
import Login from "./routes/login/index.js";

import Home from "./routes/home";
import Jobs from "./routes/jobs";
import ChangePassword from "./routes/change-password";


import Job from "./modals/job.js";
import ViewJob from "./modals/viewjob.js";

import NiceModal, { ModalDef, useModal } from '@ebay/nice-modal-react';





if (getStorage('token')) {
  useStore.setState({ auth: 1 });
  //setAuth('1');

}
function AuthRoute({ children }) {
  const auth = useStore((state) => state.auth)
  let location = useLocation();
  const org = useStore((state) => state.org)
  if (!auth) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }





  return children;
}


function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}





export default function App() {

  const idleTimerRef = useRef(null);
  const location = useLocation();
  useEffect(() => {


  }, [location]);

  const navigate = useNavigate();

  React.useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);



  return (
    <>

      <Routes>

        <Route path="/" element={<MainLayout />}  >
          <Route path="/" element={<AuthRoute><Home /></AuthRoute>} />
          <Route path="jobs" element={<AuthRoute><Jobs /></AuthRoute>} />
          <Route path="change-password" element={<AuthRoute><ChangePassword /></AuthRoute>} />



        </Route>

        <Route path="*" element={<NoMatch />} />
        <Route path="/login" element={<Login />} />


      </Routes>
      <ModalDef id="job" component={Job} />

      <ModalDef id="view-job" component={ViewJob} />


    </>
  );
}





// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
